import React from 'react';

const BottomContent = () => (
  <section className="content-section bottom">
    <header>
      <h1>Enhance Your Thumbnails</h1>
      <p>Explore advanced features to make your thumbnails stand out.</p>
    </header>
    <div className="features">
      <article>
        <h2>Custom Templates</h2>
        <p>Utilize our custom templates to create unique and eye-catching thumbnails.</p>
        {/* Ensure this link points to an existing page or remove it */}
        {/* <a href="/templates" title="Explore custom templates for thumbnails">Explore Templates</a> */}
      </article>
      <article>
        <h2>Editing Tools</h2>
        <p>Access a variety of editing tools to perfect your thumbnail designs.</p>
        {/* Ensure this link points to an existing page or remove it */}
        {/* <a href="/tools" title="Discover editing tools for thumbnails">Discover Tools</a> */}
      </article>
    </div>
  </section>
);

export default BottomContent;